import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import "./App.css";
import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import Home from "./pages/Home";
import Auth from "./pages/Auth";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useToken from "./hooks/useToken";
import NavBar from "./components/NavBar";
import Firmalar from "./components/firmalar";
import Urunler from "./components/urunler";
import KiralamaListesi from "./components/kiralamaListesi";
import KiralamaEditor from "./components/kiralamaEditor";
import HomeLayout from "./pages/HomeLayout";
import Onaybekleyenler from "./components/onaybekleyenler"
import TeklifFormuOlustur from "./components/teklifformuolustur";
import TahsilatTakibi from "./components/tahsilatTakibi";

import { Navigate } from "react-router-dom";

function AppContent() {
  const [token] = useToken();
  const location = useLocation(); // 🔹 useLocation burada kullanılıyor

  // 🔹 Eğer /auth sayfasındaysak özel arka plan, değilse beyaz yap
  const isAuthPage = location.pathname === "/auth";
  

  return (
    <div className={`app-container ${isAuthPage ? "auth-bg" : "white-bg"}`}>
      {token?.token && <NavBar />}
      <div className="content-container">
      <Routes>
  <Route
    path="/auth"
    element={<Auth />}
  />
  
  {/* token varsa aşağıdaki rotaları göster */}
  {token?.token && (
    <Route path="/home" element={<HomeLayout />}>
      <Route index element={<Home />} /> {/* /home */}
      <Route path="firmalar" element={<Firmalar />} /> {/* /home/firmalar */}
      <Route path="urunler" element={<Urunler />} /> {/* /home/urunler */}
      <Route path="kiradakiurunler" element={<KiralamaListesi />} /> {/* /home/kiradakiurunler */}
      <Route path="kiradakiurunler/yeni" element={<KiralamaEditor />} /> {/* /home/kiradakiurunler/yeni */}
      <Route path="kiradakiurunler/:kiralamaId" element={<KiralamaEditor />} /> {/* /home/kiradakiurunler/:id */}
      <Route path="onaybekleyenler" element={<Onaybekleyenler />} /> {/* /home/Onaybekleyenler */}
      <Route path="teklifformuolustur" element={<TeklifFormuOlustur />} /> {/* /home/kiradakiurunler */}
      <Route path="tahsilattakibi" element={<TahsilatTakibi />} /> {/* /home/tahsilattakibi */}

    </Route>
  )}

  {/* kök dizine girince yönlendir /home'a */}
  <Route
    path="/"
    element={<Navigate to={token?.token ? "/home" : "/auth"} replace />}
  />
</Routes>
      </div>
      <ToastContainer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent /> {/* 🔹 useLocation burada iç içe çalışıyor */}
    </BrowserRouter>
  );
}

export default App;
